export function filterObject<T = {}, U = {}>(obj: T, filterFn?: (key: keyof T) => boolean) {
  const keys = Object.keys(obj as {}) as (keyof T)[]

  return keys.reduce((prev, cur) => {
    if (filterFn) {
      if (filterFn(cur)) {
        return {
          ...prev,
          [cur]: obj[cur],
        }
      }

      return prev
    }

    return {
      ...prev,
      [cur]: obj[cur],
    }
  }, {} as U)
}

/**
 * 주어진 size 만큼 배열을 쪼개는 함수
 * @param data 배열
 * @param size 쪼개는 단위
 */
export const splitArray = (data: Array<unknown>, size: number) => {
  const count = Math.floor(data.length / size) + Math.floor(data.length % size) > 0 ? 1 : 0
  const resultData = []

  for (let i = 0; i <= count; i++) {
    if (!data.length) break
    resultData.push(data.splice(0, size))
  }

  return resultData
}

/**
 * 주어진 size 만큼 배열을 역순으로 쪼개는 함수
 * @param data 배열
 * @param size 쪼개는 단위
 */
export const reverseSplitArray = (data: Array<unknown>, size: number) => {
  const count = Math.floor(data.length / size) + (data.length % size > 0 ? 1 : 0)
  const resultData = []

  for (let i = count - 1; i >= 0; i--) {
    const startIndex = i * data.length
    const endIndex = startIndex - size
    if (endIndex < 0) break
    resultData.push(data.splice(endIndex, startIndex))
  }

  if (data.length) resultData.unshift(data)

  return resultData
}
